import { Heading, Input, Tag, Text } from "@ttc3k/trekker";
import { Box, Divider, Flex } from "styled-system/jsx";
import { useBookerContext } from "widgets/booker/contexts";
import { AnimatePresence, motion } from "framer-motion";
import { useTranslation } from "react-i18next";

type GuestNamesProps = {
  guestNames: string[];
  onUpdateGuestNames: (name: string, index: number) => void;
};

export const GuestNames = ({
  guestNames,
  onUpdateGuestNames,
}: GuestNamesProps) => {
  const { product } = useBookerContext();
  const { t } = useTranslation("booker", {
    keyPrefix: "GUESTS_PAGE.GUEST_NAMES",
  });

  const guestMetadata = product?.accommodationMetadata?.guestMetadata;
  if (!guestMetadata?.nameEntryAllowed && !guestMetadata?.nameEntryRequired) {
    return null;
  }
  return (
    <Flex flexDir={"column"} gap={"250"}>
      <Flex width={"full"} gap={"200"} alignItems={"center"}>
        <Box w={"max-content"}>
          <Heading size={"h5"} color={"text.dark"} w={"max-content"}>
            {t("TITLE")}
          </Heading>
        </Box>
        <Divider borderColor={"border.light"} />
        <Box w={"max"}>
          {guestMetadata?.nameEntryRequired ? (
            <Tag visual={"warning"}> {t("REQUIRED")}</Tag>
          ) : (
            <Tag visual={"primary"} mode={"light"}>
              {t("OPTIONAL")}
            </Tag>
          )}
        </Box>
      </Flex>
      <Text color={"text.mid"}>{t("DESCRIPTION")}</Text>
      <AnimatePresence>
        {guestNames.map((g, i) => {
          return (
            <motion.div
              key={i}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2, ease: "easeInOut" }}
            >
              <Input
                label={`${t("GUEST")} ${i + 1}`}
                value={g}
                onChange={e => {
                  onUpdateGuestNames(e.target.value, i);
                }}
                bg={"white"}
              />
            </motion.div>
          );
        })}
      </AnimatePresence>
    </Flex>
  );
};
